import { RouteState } from "@/router/RouteState";

const LABELS: Record<string, string> = {
  quote: "현장견적",
  market: "사급단가",
  ledger: "수불입력",
  cost: "원가 관리",
  mix: "배합비 관리",
  sales: "판매관리",
};

export function ComingSoon({ pageKey }: { pageKey: string }) {
  if (pageKey === "not-found") {
    return <RouteState kind="not-found" description={<>주소가 바뀌었거나 없는 페이지예요.<br />주소를 다시 확인해 주세요.</>} />;
  }
  return <RouteState kind="coming-soon" description={<>아직 준비 중인 {LABELS[pageKey] || "업무"} 화면이에요.<br />다른 메뉴를 이용해 주세요.</>} />;
}
